import { Outlet } from "react-router-dom";
import { ToastContainer, Zoom, toast } from "react-toastify";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "../src/styles/main.scss";
import ScrollToTop from "./components/ScrollToTop";
import OldDashboardLayout from "./Layouts/OldDashboardLayout";
import NewDashboardLayout from "./Layouts/NewDashboardLayout";
function App() {
  const { userInfo } = useSelector((state) => state.auth);
  const roleId = Number(userInfo?.role);

  const Layout = roleId === 1 ? OldDashboardLayout : NewDashboardLayout;
  return (
<>
    <ScrollToTop/>
<Layout>
  <Outlet />
</Layout>;
</>
  );
}

export default App;
